/**
 * Created by zed on 2021/10/11
 * Copyright © 2017 www.moemone.com. All rights reserved.
 *
 * 【数据模拟】古琴汇 - 应用官网
 */
import Mocker from "@/mock/mocker"

const prefix = process.env.VUE_APP_BASE_API
const oss = 'https://moemone-cms-test.oss-cn-shenzhen.aliyuncs.com/5f861e7aefdf1a5c/site'

// 关于我们
Mocker.getSuccess(`${prefix}/api/about`, {
  titleBG: "https://moemone-cms-test.oss-cn-shenzhen.aliyuncs.com/ringle/about_text_gray.png",    // 企业名称背景图
  facadeBG: "https://moemone-cms-test.oss-cn-shenzhen.aliyuncs.com/ringle/12275680_1341814069050_3200x1200.jpg"   // 企业门面背景图
})

// 产品介绍
Mocker.getSuccess(`${prefix}/api/introduce`, [
  {
    title: '琴馆信息数字展示',
    content: '手机实时了解琴馆师资环境，一键联系先预约，地图导航不迷路',
    image: `${oss}/icon_introduce_remote.png`,
  },
  {
    title: '琴曲演奏录制收听',
    content: '录制自己演奏的作品与琴友分享。更可收藏定制自己的琴曲乐库随时收听',
    image: `${oss}/icon_introduce_connect.png`,
  },
  {
    title: '琴课视频物料教学',
    content: '海量古琴教学视频，轻松攻克演奏难点及文学意境。随时跟名家学古琴',
    image: `${oss}/icon_introduce_app.png`,
  },
])

// 合作伙伴
Mocker.getSuccess(`${prefix}/api/partners`, null)

// 联系我们
// Mocker.getSuccess(`${prefix}/api/contact`, {
//   // 企业可能存在多家分公司
//   companies: [{
//     name: "深圳市云宠智能科技有限公司",
//     location: {
//       province: "广东省",
//       city: "深圳市",
//       area: "龙岗区",
//       street: "龙城街道",
//       address: "爱联社区中粮祥云2栋A座2904-02",
//       image: "https://moemone-cms-test.oss-cn-shenzhen.aliyuncs.com/ringle/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC-%E4%BC%81%E4%B8%9A%E9%97%A8%E9%9D%A2.jpeg"
//     },
//     contact: {
//       phone: "(0755) 28968332",
//       mobile: "(86) 13510461265",
//       email: "yunchong@vip.163.com",
//       image: "https://moemone-cms-test.oss-cn-shenzhen.aliyuncs.com/ringle/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC-%E4%BD%8D%E7%BD%AE%E6%88%AA%E5%9B%BE.png"
//     }
//   }]
// })
